import CustomerApplicationDetail from "../CustomerApplicationDetail";

export function CustomerApplicationAdverseAlertTab() {
	return (
		<CustomerApplicationDetail>
			<CustomerApplicationDetail.Title title="Adverse alerts" />
		</CustomerApplicationDetail>
	);
}